import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for List
export const List = createSlice({
  name: "list",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_List: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_List: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_List: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    List_is_first: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default List.reducer;
export const {
  list_List,
  success_api_call_List,
  failure_api_call_List,
  List_is_first,
} = List.actions;
